import { SheetTabsProps } from '../types';

export function SheetTabs({ tabs, activeTab, onTabChange, className = '' }: SheetTabsProps) {
  return (
    <div className={`flex items-end bg-gray-100 border-t border-gray-200 ${className}`}>
      <div className="flex items-end overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              px-4 py-2 text-sm font-medium border-r border-gray-300 transition-colors
              whitespace-nowrap min-w-fit flex-shrink-0 relative
              ${activeTab === tab.id 
                ? 'bg-white text-gray-900' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-50 hover:text-gray-800'
              }
            `}
            style={tab.bottomBorderColor ? {
              borderBottom: `3px solid ${tab.bottomBorderColor}`
            } : undefined}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex-1 border-r border-gray-200 bg-gray-100 h-8"></div>
    </div>
  );
} 